/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs */



/**
* | output |
* | --- |
* | "Dialogue With Speaker Id" |
*
* @param {Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_dialogue_with_speaker_id = /** @type {((inputs?: Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Dialogue_With_Speaker_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue avec ID intervenant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog mit Sprecher-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo con ID relatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диалог с идентификатором говорящего")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo con ID de orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("与说话人 ID 对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("話者IDとの対話")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता आईडी के साथ संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo com ID do falante")
	return /** @type {LocalizedString} */ ("Dialogue With Speaker Id")
});